class SliderPress extends HTMLElement {
  constructor() {
    super();

    this.mainSliderElement = this.querySelector("[data-slider-main]");
    this.thumbsSliderElement = this.querySelector("[data-slider-thumbs]");
    this.thumbsSlidesCount = Number(this.thumbsSliderElement?.dataset?.slidesCount || 0);

    if (this.mainSliderElement && this.thumbsSliderElement) {
      this.mainSlider = new Splide(this.mainSliderElement, {
        pagination: false,
        waitForTransition: false,
        arrows: false,
      });
      this.thumbsSlider = new Splide(this.thumbsSliderElement, {
        pagination: false,
        waitForTransition: false,
        arrows: false,
        drag: false,
        isNavigation: true,
        perPage: this.thumbsSlidesCount,
        breakpoints: {
          1200: {
            perPage: this.thumbsSlidesCount >= 4 ? 4 : this.thumbsSlidesCount
          },
          990: {
            perPage: this.thumbsSlidesCount >= 3 ? 3 : this.thumbsSlidesCount
          },
          750: {
            perPage: 1
          },
        },
      }).mount();

      this.mainSlider.sync(this.thumbsSlider).mount();
    }
  }
}

customElements.define("slider-press", SliderPress);
